export const userColors = [
    "#607D8B",
    "#00C7B5",
    "#03A9F4",
    "#9575CD",
    "#F06292",
    "#FF9800",
];
export const priorityColors = [
    "#ff5252",
    "#ffc975",
    "#0ab169",
    "#607D8B",
    "#00C7B5",
    "#03A9F4",
    "#9575CD",
    "#F06292",
    "#FF9800",
];
export const defaultTaskShape = {
    counter: {
        type: "number",
    },
    date: {
        format: "%d %M %Y",
        validate: true,
    },
    completed: {
        behavior: "auto",
        taskHide: false,
    },
    priority: {
        label: true,
        cover: true,
    },
};
export const defaultDragConfig = {
    expand: true,
};
export const defaultPriorities = [
    {
        id: 1,
        label: "High",
        color: "#ff5252",
        hotkey: "Alt+1",
    },
    {
        id: 2,
        label: "Medium",
        color: "#ffc975",
        hotkey: "Alt+2",
    },
    {
        id: 3,
        label: "Low",
        color: "#0ab169",
        hotkey: "Alt+3",
    },
];
//# sourceMappingURL=constants.js.map